export default "__VITE_ASSET__BOthrLlx__"